import { render } from "./BookingAsideAccordion.vue?vue&type=template&id=fa9ef314"
import script from "./BookingAsideAccordion.vue?vue&type=script&lang=js"
export * from "./BookingAsideAccordion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/BookingAsideAccordion.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fa9ef314"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fa9ef314', __exports__)) {
    api.reload('fa9ef314', __exports__)
  }
  
  module.hot.accept("./BookingAsideAccordion.vue?vue&type=template&id=fa9ef314", () => {
    api.rerender('fa9ef314', render)
  })

}


export default __exports__